/*
 * @Description:
 * @Date: 2024-03-20 20:25:35
 */
import { onMounted, onUnmounted, ref } from 'vue';
export const useParentHeight = () => {
  return (() => {
    const parentDomHeight = ref('50vh');
    const reset = () => {
      requestAnimationFrame(() => {
        const parent = document.querySelector(
          '#subapp-container'
        ) as HTMLDivElement;
        if (parent) {
          const oldHeight = parent.style.height;
          parent.style.height = '100%';
          parentDomHeight.value = parent.clientHeight + 'px';
          parent.style.height = oldHeight;
        }
      });
    };
    window.addEventListener('resize', reset);
    onMounted(reset);
    onUnmounted(() => {
      window.removeEventListener('resize', reset);
    });

    return parentDomHeight;
  })();
};
